<div
    class="pass--wrapper card"
    tabindex="0"
    data-testid="t-card-div-1752672977568-54"
>
    <div
        class="card-body"
        data-testid="t-card-div-1752672977568-53"
    >
        <div
            class="pass--title-bar"
            data-testid="t-card-div-1752672977568-5"
        >
            <div
                class="row g-3 align-items-center"
                data-testid="t-card-div-1752672977568-4"
            >
                <div
                    class="col"
                    data-testid="t-card-div-1752672977568-1"
                >
                    <span
                        class="h4 fw-bold"
                        data-testid="t-card-span-1752672977568-1"
                    >
                        {{ 'mws.supplierpass' | i18n }}
                    </span>
                </div>
                @if (!supplierContractCostcenterStatus) {
                    <div
                        class="col text-end"
                        data-testid="t-card-div-1752672977568-2"
                    >
                        <strong
                            class="d-none d-md-inline-block me-2 align-middle"
                            data-testid="t-card-strong-1752672977568-1"
                            >{{ 'mws.status' | i18n }}:</strong
                        >
                        @if (supplierService.supplierBasedataStateHash.get(stateEnum.UNCOMPLETE) > 0) {
                            <span
                                class="badge badge bg-danger"
                                data-testid="t-card-span-1752672977568-2"
                            >
                                {{ 'mws.uncomplete' | i18n }}
                            </span>
                        }
                        @if (supplierService.supplierBasedataStateHash.get(stateEnum.COMPLETE) > 0) {
                            <span
                                class="badge badge bg-secondary"
                                data-testid="t-card-span-1752672977568-3"
                            >
                                {{ 'mws.complete' | i18n }}
                            </span>
                        }
                        @if (supplierService.supplierBasedataStateHash.get(stateEnum.ARCHIVED)) {
                            <span
                                class="badge bg-gray"
                                data-testid="t-card-span-1752672977568-4"
                            >
                                {{ 'mws.archived' | i18n }}
                            </span>
                        }
                        @if (supplierService.supplierBasedataStateHash.get(stateEnum.ENABLED)) {
                            <span
                                class="badge badge bg-success"
                                data-testid="t-card-span-1752672977568-5"
                            >
                                {{ 'mws.enabled' | i18n }}
                            </span>
                        }
                    </div>
                }
                @if (supplierContractCostcenterStatus) {
                    <div
                        class="col text-end"
                        data-testid="t-card-div-1752672977568-3"
                    >
                        <strong
                            class="d-none d-md-inline-block me-2 align-middle"
                            data-testid="t-card-strong-1752672977568-2"
                            >{{ 'mws.status' | i18n }}:</strong
                        >
                        @if (supplierContractCostcenterStatus.status.isUncomplete) {
                            <span
                                class="badge badge bg-danger"
                                data-testid="t-card-span-1752672977568-6"
                            >
                                {{ 'mws.uncomplete' | i18n }}
                            </span>
                        }
                        @if (supplierContractCostcenterStatus.status.isComplete) {
                            <span
                                class="badge badge bg-secondary"
                                data-testid="t-card-span-1752672977568-7"
                            >
                                {{ 'mws.complete' | i18n }}
                            </span>
                        }
                        @if (supplierContractCostcenterStatus.status.isArchived) {
                            <span
                                class="badge bg-gray"
                                data-testid="t-card-span-1752672977568-8"
                            >
                                {{ 'mws.archived' | i18n }}
                            </span>
                        }
                        @if (supplierContractCostcenterStatus.status.isEnabled) {
                            <span
                                class="badge badge bg-success"
                                data-testid="t-card-span-1752672977568-9"
                            >
                                {{ 'mws.enabled' | i18n }}
                            </span>
                        }
                    </div>
                }
            </div>
        </div>

        <div
            class="pass--body"
            data-testid="t-card-div-1752672977568-52"
        >
            <div
                class="pass--info-block"
                data-testid="t-card-div-1752672977568-21"
            >
                <div
                    class="row g-3"
                    data-testid="t-card-div-1752672977568-20"
                >
                    @if (supplierService.supplierBasedata.imageId) {
                        <div
                            class="col-12 col-sm-6 order-md-2"
                            data-testid="t-card-div-1752672977568-7"
                        >
                            <div
                                class="pass--logo text-end"
                                data-testid="t-card-div-1752672977568-6"
                            >
                                <img
                                    loading="lazy"
                                    [src]="imagePath"
                                    alt=""
                                    style="max-width: 140px"
                                    class="ms-auto d-inline-block"
                                    data-testid="t-card-img-1752672977568-1"
                                />
                            </div>
                        </div>
                    }

                    <div
                        class="col-12 col-sm-6"
                        data-testid="t-card-div-1752672977568-19"
                    >
                        <div
                            class="row g-3"
                            data-testid="t-card-div-1752672977568-18"
                        >
                            <div
                                class="col-auto"
                                data-testid="t-card-div-1752672977568-12"
                            >
                                <div
                                    class="info--wrapper"
                                    data-testid="t-card-div-1752672977568-11"
                                >
                                    <div
                                        class="info"
                                        data-testid="t-card-div-1752672977568-10"
                                    >
                                        <div
                                            class="text-muted small line-height-1"
                                            data-testid="t-card-div-1752672977568-8"
                                        >
                                            {{ 'mws.suppliername' | i18n }}
                                        </div>
                                        <div data-testid="t-card-div-1752672977568-9">
                                            {{ supplierService.supplierBasedata.name }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div
                                class="col-auto"
                                data-testid="t-card-div-1752672977568-17"
                            >
                                <div
                                    class="info--wrapper"
                                    data-testid="t-card-div-1752672977568-16"
                                >
                                    <div
                                        class="info"
                                        data-testid="t-card-div-1752672977568-15"
                                    >
                                        <div
                                            class="text-muted small line-height-1"
                                            data-testid="t-card-div-1752672977568-13"
                                        >
                                            {{ 'mws.costcenters' | i18n }}
                                        </div>
                                        <div data-testid="t-card-div-1752672977568-14">
                                            {{ actualCostcenterInfo() }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            @if (coreService.checkAbility('execute', 'suppliercontact')) {
                <div
                    class="pass--info-block"
                    data-testid="t-card-div-1752672977568-32"
                >
                    <div
                        class="separator"
                        data-testid="t-card-div-1752672977568-22"
                    >
                        {{ 'mws.contacts' | i18n }}
                    </div>
                    @for (contact of supplierContacts(); track contact) {
                        <div
                            class="pass--section-wrapper"
                            data-testid="t-card-div-1752672977568-31"
                        >
                            <div
                                class="pass--section"
                                data-testid="t-card-div-1752672977568-30"
                            >
                                <div
                                    class="row g-3"
                                    data-testid="t-card-div-1752672977568-26"
                                >
                                    <div
                                        class="col-md"
                                        data-testid="t-card-div-1752672977568-24"
                                    >
                                        <div
                                            class="text-muted small"
                                            data-testid="t-card-div-1752672977568-23"
                                        >
                                            {{ 'mws.surname' | i18n }}, {{ 'mws.firstname' | i18n }}
                                        </div>
                                        @if (coreService.checkAbility('read', 'suppliercontact.lastname')) {
                                            <span data-testid="t-card-span-1752672977568-10">{{ contact.lastName }},</span>
                                        }
                                        @if (coreService.checkAbility('read', 'suppliercontact.firstname')) {
                                            <span data-testid="t-card-span-1752672977568-11">{{ contact.firstName }}</span>
                                        }
                                    </div>
                                    <div
                                        class="col-md-auto"
                                        data-testid="t-card-div-1752672977568-25"
                                    >
                                        @if (contact.isFavorite === true) {
                                            <span
                                                class="btn btn-primary action--btn no-button"
                                                data-testid="t-card-span-1752672977568-12"
                                            >
                                                <i
                                                    [ngbTooltip]="'mws.favorite' | i18n"
                                                    class="oc-heart-filled d-inline-block"
                                                    data-testid="t-card-i-1752672977568-1"
                                                ></i>
                                            </span>
                                        }
                                        @if (contact.isEmergency === true) {
                                            <span
                                                class="no-button action--btn btn btn-danger"
                                                [ngbTooltip]="'mws.emergency' | i18n"
                                                data-testid="t-card-span-1752672977568-13"
                                            >
                                                <i
                                                    class="oc-general-danger d-inline-block"
                                                    data-testid="t-card-i-1752672977568-2"
                                                ></i>
                                            </span>
                                        }
                                    </div>
                                </div>
                                <div
                                    class="row g-3"
                                    data-testid="t-card-div-1752672977568-29"
                                >
                                    @for (detail of contact.contactDetails; track detail) {
                                        <div
                                            class="col-md-6"
                                            data-testid="t-card-div-1752672977568-28"
                                        >
                                            @if (coreService.checkAbility('read', 'supplier.contact.detail.contacttypeid')) {
                                                <div
                                                    class="text-muted small"
                                                    data-testid="t-card-div-1752672977568-27"
                                                >
                                                    f
                                                    {{ environmentService.getContactTypeById(detail.contactTypeId)?.descr }}
                                                </div>
                                            }
                                            @if (coreService.checkAbility('read', 'supplier.contact.detail.contactinfo')) {
                                                <span data-testid="t-card-span-1752672977568-14">{{ detail.contactInfo }}</span>
                                            }
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    }
                </div>
            }
            @if (coreService.checkAbility('execute', 'supplier.mainaddress')) {
                <div
                    class="pass--info-block"
                    data-testid="t-card-div-1752672977568-45"
                >
                    <div
                        class="separator"
                        data-testid="t-card-div-1752672977568-33"
                    >
                        {{ 'mws.baseaddress' | i18n }}
                    </div>
                    <div
                        class="pass--section-wrapper"
                        data-testid="t-card-div-1752672977568-44"
                    >
                        <div
                            class="pass--section"
                            data-testid="t-card-div-1752672977568-41"
                        >
                            <div
                                class="row g-3"
                                data-testid="t-card-div-1752672977568-40"
                            >
                                @if (coreService.checkAbility('read', 'supplier.mainaddress.postalcode')) {
                                    <div
                                        class="col-md-6"
                                        data-testid="t-card-div-1752672977568-35"
                                    >
                                        <div
                                            class="text-muted small"
                                            data-testid="t-card-div-1752672977568-34"
                                        >
                                            {{ 'mws.address.postalcode' | i18n }}
                                        </div>
                                        {{ supplierService.supplierBasedata?.mainAddress?.address?.postalCode }}
                                    </div>
                                }
                                @if (coreService.checkAbility('read', 'supplier.mainaddress.city')) {
                                    <div
                                        class="col-md-6"
                                        data-testid="t-card-div-1752672977568-37"
                                    >
                                        <div
                                            class="text-muted small"
                                            data-testid="t-card-div-1752672977568-36"
                                        >
                                            {{ 'mws.address.city' | i18n }}
                                        </div>
                                        {{ supplierService.supplierBasedata?.mainAddress?.address?.city }}
                                    </div>
                                }
                                @if (coreService.checkAbility('read', 'supplier.mainaddress.country')) {
                                    <div
                                        class="col-md-12"
                                        data-testid="t-card-div-1752672977568-39"
                                    >
                                        <div
                                            class="text-muted small"
                                            data-testid="t-card-div-1752672977568-38"
                                        >
                                            {{ 'mws.address.country' | i18n }}
                                        </div>
                                        {{ environmentService.getStateById(supplierService.supplierBasedata?.mainAddress?.address?.stateId)?.descr }}
                                    </div>
                                }
                            </div>
                        </div>
                        @if (coreService.checkAbility('read', 'supplier.mainaddress.street')) {
                            <div
                                class="pass--section"
                                data-testid="t-card-div-1752672977568-43"
                            >
                                <div
                                    class="text-muted small"
                                    data-testid="t-card-div-1752672977568-42"
                                >
                                    {{ 'mws.address.street' | i18n }}
                                </div>
                                {{ supplierService.supplierBasedata?.mainAddress?.address?.street }}
                            </div>
                        }
                    </div>
                </div>
            }

            @if (supplierService.supplierContractDetail) {
                <div
                    class="pass--info-block"
                    data-testid="t-card-div-1752672977568-47"
                >
                    <div
                        class="separator"
                        data-testid="t-card-div-1752672977568-46"
                    >
                        {{ 'mws.discounts' | i18n }}
                    </div>
                    <app-discounts
                        [showButtons]="false"
                        [showHeadline]="false"
                        [privilegeContext]="'supplier'"
                        data-testid="t-card-app-discounts-1752672977568-1"
                    ></app-discounts>
                </div>
            }

            <div
                class="pass--info-block"
                data-testid="t-card-div-1752672977568-49"
            >
                <div
                    class="separator"
                    data-testid="t-card-div-1752672977568-48"
                >
                    {{ 'mws.certifications' | i18n }}:
                </div>

                <app-certification
                    [showButtons]="false"
                    [showValid]="false"
                    [showHeadline]="false"
                    data-testid="t-card-app-certification-1752672977568-1"
                ></app-certification>
            </div>

            @if (actualSupplierContractCostcenterCustomer) {
                <div
                    class="pass--info-block"
                    data-testid="t-card-div-1752672977568-51"
                >
                    <div
                        class="separator"
                        data-testid="t-card-div-1752672977568-50"
                    >
                        {{ 'mws.customerdata' | i18n }}
                    </div>
                    <!--                    [indexSupplierContractCostcenters]="indexSupplierContractCostcenters"-->
                    <app-deliveryterms
                        [supplierContractCostcenterCustomer]="actualSupplierContractCostcenterCustomer"
                        [showButtons]="false"
                        [showCustomerDiv]="false"
                        [showAddresses]="false"
                        data-testid="t-card-app-deliveryterms-1752672977568-1"
                    ></app-deliveryterms>
                </div>
            }
        </div>
    </div>
</div>
